var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartsT"},[_vm._v(" "+_vm._s(_vm.lang.AppCategories)+" "),_c('div',{ref:"chartDom",staticStyle:{"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }